import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { Ng2ImgMaxService } from 'ng2-img-max';
import { Validators } from 'src/app/shared/validators';
import { CustomValidators } from 'src/app/shared/custom-validators';
import { FetchCategoriesService } from 'src/app/dashboard/admin/action/components/crm/profile/services/fetch-categories.service';
import { PostUploadedImageService } from 'src/app/dashboard/admin/action/components/crm/profile/services/post-uploaded-image.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { GetActivationRequestService } from '../../credit-card-request-form/get-activation-request.service';
import { FormValidatorService } from 'src/app/shared/services/form-validator.service';
import { LanguageService } from 'src/app/shared/services/language.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BusinessInfoResult } from '../new-activation-page.component';

@Component({
  selector: 'app-business-information',
  templateUrl: './business-information.component.html',
  styleUrls: ['./business-information.component.scss'],
})
export class BusinessInformationComponent implements OnInit {
  businessId:number
  fvBusinessInfo = new FormValidatorService();
  logoUrl: string = '';
  profileForm!: FormGroup;
  isVerifed: boolean = false;
  categoryOptions: { id: string; name: string }[] = [];
  selectedFile: File;
  facebookPattern = /^(https?:\/\/)?(www\.)?facebook.com\/[\u0621-\u064A\u0660-\u0669a-zA-Z0-9(\.\?)?]/;
  twitterPattern = /^(https?:\/\/)?(www\.)?twitter.com\/[\u0621-\u064A\u0660-\u0669a-zA-Z0-9(\.\?)?]/;
  linkedInPattern = /^(https?:\/\/)?(www\.)?linkedin.com\/[\u0621-\u064A\u0660-\u0669a-zA-Z0-9(\.\?)?]/;
  facebookLikes: number;
  emptyLogo = false;
  notOnlyNumPattern = /(?!^\d+$)^.+$/g;
  OnlyNumPattern = /^\d+$/;
  subscriptions: Subscription[] = [];

  constructor(
    private translate: TranslateService,
    private snackBar: MatSnackBar,
    private fetchCategories: FetchCategoriesService,
    private puiS: PostUploadedImageService,
    private ng2ImgMax: Ng2ImgMaxService,
    private auth: AuthService,
    public sanitizer: DomSanitizer,
    public getActivation: GetActivationRequestService,
    private languageService: LanguageService
  ) {}
  ngAfterViewInit() {
    this.translateValidationMessages();
    this.translate.onLangChange.subscribe(() => {
      this.translateValidationMessages();
    });
  }
  translateValidationMessages() {
    this.translate.get('FormValidation').subscribe(() => {
      this.fvBusinessInfo.validationMessages = {
        ...this.fvBusinessInfo.validationMessages,
        productsDescription: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Product description',
            fieldAr: 'وصف المنتج',
          }),
        },
        averagePrice: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Average price',
            fieldAr: 'متوسط السعر',
          }),
        },
        description: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'description',
            fieldAr: 'وصف العمل',
          }),
        },
        CategoryId: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Category',
            fieldAr: 'فئة العمل',
          }),
        },
      };
    });
  }
  async ngOnInit() {
    this.translate.use(localStorage.getItem('language'));
    this.languageService.languageUpdated.subscribe((lang) => {
      this.translate.use(lang);
    });
    this.businessId = (await this.auth.getBusiness()).id;
    this.profileForm = this.fvBusinessInfo.createForm([
      {
        fieldName: 'name',
        defaultValue: '',
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant('FORMS.VALIDATION.REQUIRED', {
              field: 'Business name',
            }),
          },
          {
            validatorFn: Validators.minLength(2),
            message: this.translate.instant('FORMS.VALIDATION.MINIMUM_LENGTH', {
              field: 'Business name',
              value: 2,
            }),
          },
          {
            validatorFn: CustomValidators.customPattern(this.notOnlyNumPattern),
            message: this.translate.instant('FORMS.VALIDATION.NOT_NUMBERS', {
              field: 'Business name',
            }),
          },
        ],
      },
      {
        fieldName: 'productsDescription',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
      {
        fieldName: 'description',
        defaultValue: '',
        validators: [
          {
            validatorFn: Validators.required,
            message: 'description cannot be empty',
          },
        ],
      },
      {
        fieldName: 'averagePrice',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
      {
        fieldName: 'businessLogo',
        defaultValue: null,
      },
      {
        fieldName: 'logo',
        defaultValue: '',
        validators: [
          {
            validatorFn: Validators.required,
            message: 'required',
          },
        ],
      },
      {
        fieldName: 'CategoryId',
        defaultValue: '',
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
      {
        fieldName: 'customersFromEgypt',
        defaultValue: 'inside',
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
        ],
      },
    ]);

    const categories = await this.fetchCategories.make();
    this.categoryOptions = categories;

    this.isVerifed = await this.isActiveStatus();
  }
  initFormValues(inComingValues:BusinessInfoResult) {
    Object.keys(this.profileForm.controls).forEach((control) => {
      if (inComingValues[control]) {
        this.profileForm.controls[control].setValue(inComingValues[control]);
      }
    });
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subs) => subs.unsubscribe());
  }

  onFileInput(event: any) {
    this.selectedFile = <File>event.target.files[0];
    console.log(event.target.files[0]);
    this.subscriptions.push(
      this.ng2ImgMax.compressImage(this.selectedFile, 0.2, true).subscribe(
        (result: any) => {
          this.emptyLogo = false;
          const image = new File([result], result.name);
          this.selectedFile = image;
          this.profileForm.controls['logo'].setValue(result.name);
        },
        (error: any) => {
          console.log('there is an', error);
        }
      )
    );
  }

  async onUploadImage() {
    const fd = new FormData();
    fd.append('image', this.selectedFile);
    this.puiS.setParams(fd);
    try {
      return await this.puiS.uploadImage();
    } catch (errors) {
      console.log(errors);
      throw errors;
    }
  }

  async isActiveStatus() {
    let business = await this.auth.getBusiness();
    if (!business) return false;
    if (business.activeStatus != 'UnVerified') {
      return true;
    }
    return false
  }

  async onSubmit() {
    if (this.profileForm.invalid) {
      this.fvBusinessInfo.forceShowErrors();
      return;
    }
    try {
      if (this.profileForm.controls['logo'].invalid) {
        this.emptyLogo = true;
        return;
      }
      if (this.selectedFile) {
        const uploadResult = await this.onUploadImage();
        console.log(uploadResult);
        this.profileForm.controls['logo'].setValue(uploadResult.location);
      }

      return this.profileForm.value;
    } catch (errors) {
      console.log(errors);
      this.showFormErrors(errors);
    }
  }
  showFormErrors(errors) {
    if (errors.validationErrors.error) {
      for (const e of errors.validationErrors.error) {
        this.fvBusinessInfo.addError(e.field, 'invalid', e.message);
        this.profileForm.controls[e.field].setErrors({ invalid: e.message });
        this.fvBusinessInfo.ShowErrors();
      }
    }
  }
  isComponentValid() {
    return this.profileForm.valid && this.profileForm.controls['logo'].valid ;
  }
  showComponentErrors() {
    this.fvBusinessInfo.forceShowErrors();
    this.snackBar.open(
      this.translate.instant('Sellers.Products.Invalid_Business_Info'),
      '',
      {
        duration: 5000,
      }
    );
  }
}
